// Footer.tsx — con traducciones
import type { MouseEvent } from 'react';
import { useLanguage } from '@/shared/context/LanguageContext';
import { SECTION_NAV, scrollToSection } from '@/marketing/data/sectionNav';
import { LightningIcon, LockIcon } from '@/shared/ui/Icons/Icons';
import styles from './Footer.module.css';

export function Footer() {
  const year = new Date().getFullYear();
  const { t } = useLanguage();
  const f = t.footer;

  // Misma lista que usa el Header — Servicios muestra el primer link
  // (services) y Empresa el resto (roadmap, faq, contacto), así ambos
  // navs hablan exactamente lo mismo y apuntan a las mismas secciones.
  const navLinks = SECTION_NAV.map((item) => ({ label: t.nav[item.key], href: item.href }));
  const serviceLinks = navLinks.slice(0, 1);
  const companyLinks = navLinks.slice(1);

  const handleSectionClick = (e: MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    scrollToSection(href.slice(1));
  };

  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.inner}>
        <div className={styles.brand}>
          <div className={styles.logo}><LightningIcon aria-hidden="true" /> ReInvent<span className={styles.logoAccent}>-X</span></div>
          <p className={styles.brandDesc}>{f.desc}</p>
        </div>
        <div>
          <p className={styles.colTitle}>{f.colServices}</p>
          <ul className={styles.links}>
            {serviceLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={(e) => handleSectionClick(e, link.href)}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className={styles.colTitle}>{f.colCompany}</p>
          <ul className={styles.links}>
            {companyLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={(e) => handleSectionClick(e, link.href)}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={styles.bottom}>
        <span>© {year} ReInvent-X · {f.rights}</span>
        <span><LockIcon aria-hidden="true" /> {f.privacy}</span>
      </div>
    </footer>
  );
}
